import type { MetaFunction } from 'react-router';

import { canonicalTag } from '@jane/bloom/resources/meta/canonicalTag';
import { createMetaVariables } from '@jane/bloom/resources/meta/createMetaVariables';
import { getMetaDescription } from '@jane/bloom/resources/meta/description';
import { getRootLoaderData } from '@jane/bloom/resources/meta/getRootLoaderData';
import { parentMeta } from '@jane/bloom/resources/meta/parentMeta';
import { preloadImage } from '@jane/bloom/resources/meta/preloadImage';
import { getMetaTitle } from '@jane/bloom/resources/meta/title';
import type { loader } from '@jane/bloom/routes/_menu.($storeSlug).shop-all._index/route';

export const categoryRouteMeta: MetaFunction<typeof loader> = (args) => {
  const { customSEO, menuUrl, metaProps } = getRootLoaderData(args);
  const data = args.loaderData;

  const category = data?.category;

  // Match metaProps to available customSEO variables
  const metaVariables = createMetaVariables(metaProps, {
    category: category ? `${data?.customCategoryLabels?.[category]}` : 'all',
    /** @todo remove; included for backwards compatibility until menus have migrated to reference `{{category}}` */
    tabName: category ? `${data?.customCategoryLabels?.[category]}` : 'all',
  });

  const aboveTheFoldImages = (data?.menuProductImgsAboveTheFold || [])
    .map((product) => product.imageSrcSet?.fallbackSrc)
    .filter((value, index, array) => array.indexOf(value) === index);

  return [
    getMetaTitle(
      category ? customSEO?.category : customSEO?.shopAll,
      metaVariables
    ),
    getMetaDescription(
      category ? customSEO?.category : customSEO?.shopAll,
      metaVariables
    ),
    canonicalTag(args.location, menuUrl),
    ...aboveTheFoldImages.map(preloadImage),
    ...parentMeta(args),
  ];
};
